<template>
	<!-- banner -->
	<PageSlider2></PageSlider2>
	<!-- END banner -->

	<!-- numeros -->
	<section class="ftco-counter img bg-light">
		<div v-if="numeros != ''" class="container">
			<div class="row">
				<div v-for="numerosTxt in numeros" :key="numerosTxt.itiId"
					class="col-md-3 justify-content-center counter-wrap ">
					<div class="block-18 d-flex">
						<div class="icon d-flex justify-content-center align-items-center">
							<img :src="$imgURL + numerosTxt.insInstitucionalImagens[0].itgUrlImagem" style="width: 80px; border-radius: 50%;">

						</div>
						<div class="text">
							<strong class="number d-flex">
								<VueJsCounter :start="0" :end="numerosTxt.itiNome" :duration="7000" class="number counter-wrap" style=" font-weight: 500; font-size: 45px; color: #000;" /> {{ numerosTxt.itiCampoExtra1 }}
							</strong>

							<span style="color: #999; line-height: 12px;">{{ numerosTxt.itiReferencia }}</span>
						</div>

					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- END numeros -->

	<!-- produtos em destaque -->
	<section class="ftco-section ftco-project">
		<div v-if="produtosDestaque != ''" class="container-fluid px-md-4">
			<div class="row justify-content-center pb-5" v-if="titulosHome != ''">
				<div class="col-md-12 heading-section text-center ">
					<span class="subheading">{{ titulosHome[0].itiNome }}</span>
					<h2 class="mb-4">{{ titulosHome[0].itiReferencia }}</h2>
				</div>
			</div>
			<div class="row prod-destaq">
				<div v-for="produtosHome in produtosDestaque" :key="produtosHome.itiId" class="col-md-3">
					<div class="project img shadow  d-flex justify-content-center align-items-center"
						:style="{ backgroundImage: 'url(' + $imgURL + produtosHome.insInstitucionalImagens[0].itgUrlImagem + ')' }">
						<div class="overlay"></div>
						<div class="text text-center p-4">
							<h3><router-link :to="'/produtosdetalhe/' + produtosHome.itiId + '/' + formataLink(produtosHome.itiNome)">{{ produtosHome.itiNome }}</router-link></h3>
						</div>
					</div>
				</div>
			</div>

		</div>
	</section>
	<!-- END produtos em destaque -->

	<!-- callaction -->
	<PageCallAction></PageCallAction>
	<!-- END callaction -->

	<!-- noticias -->
	<section class="ftco-section bg-light">
		<div v-if="titulosHome != ''" class="container">
			<div class="row justify-content-center mb-5 pb-5">
				<div class="col-md-7 heading-section text-center">
					<span class="subheading">{{ titulosHome[0].itiCampoExtra1 }}</span>
					<h2 class="mb-4">{{ titulosHome[0].itiCampoExtra2 }}</h2>
				</div>
			</div>

			<div v-if="noticiasHome.length > 0" class="row d-flex">
				<div v-for="noticia in noticiasHome" :key="noticia.itiId" class="col-md-4 d-flex ">
					<div class="blog-entry justify-content-end">
						<router-link :to="'/noticiasDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)" class="block-20"><img :src="$imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem" class="img-fluid" style="object-fit: cover; height: 233px; border-radius: 8px; border: 1px solid #ccc">
						</router-link>
						<div class="text mt-3 float-right d-block">
							<div class="d-flex align-items-center mb-3 meta">
								<p class="mb-0">
									<span class="mr-2">{{ formattedDate(noticia.itiData1) }}</span>
								</p>
							</div>
							<h3 class="heading">{{ noticia.itiNome }}</h3>
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- END noticias -->

	<!-- depoimentos -->
	<section class="ftco-section testimony-section cinza">
		<div class="container">
			<div v-if="titulosHome != ''" class="row justify-content-center pb-3">
				<div class="col-md-12 heading-section heading-section-white text-center">
					<span class="subheading">{{ titulosHome[0].itiCampoExtra3 }}</span>
					<h2 class="mb-4" style="padding-bottom: 30px;">{{ titulosHome[0].itiCampoExtra4 }}</h2>
				</div>
			</div>
			<div v-if="listaDepoimentos.length > 0" class="row">
				<div class="col-md-12">
					<div class="carousel-testimony">
						<div class="item alinhar_coluna" >
							<Swiper :navigation="false" :pagination="{ clickable: true }" :slides-per-view="3"
								:space-between="60"
								:breakpoints="{ 768: { slidesPerView: 3 }, 0: { slidesPerView: 1 } }" >
								<SwiperSlide v-for="(item, index) in listaDepoimentos" :key="index">
									<div class="testimony-wrap py-4" style="min-height: 430px;">
										<div class="text">

											<p class="mb-4" v-html="item.itiResumo1"></p>
											<div class="d-flex align-items-center">
												<div class="user-img"><img style="width: 80px; border-radius: 50%;"
														:src="$imgURL + item.insInstitucionalImagens[0].itgUrlImagem">
												</div>
												<div class="pl-3">
													<p class="name"> {{ item.itiNome }}</p>
													<span class="position">{{ item.itiReferencia }}</span>
												</div>
											</div>
										</div>
									</div>
								</SwiperSlide>
							</Swiper>
						</div>

					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- END depoimentos -->

	<!-- marcas -->
	<section class="ftco-section bg-light">
		<div v-if="titulosHome != '' && listaMarcas.length > 0" class="container">
			<div class="row justify-content-center mb-5 pb-5">
				<div class="col-md-7 heading-section text-center ">
					<span class="subheading"> {{ titulosHome[0].itiCampoExtra5 }}</span>
					<h2 class="mb-4">{{ titulosHome[0].itiCampoExtra6 }}</h2>
				</div>
			</div>
			<div v-if="listaMarcas.length > 0" class="row d-flex">
				<div v-for="algumasMarcas in listaMarcas" :key="algumasMarcas.itiId" class="col-md-3">
					<div class="marcas img shadow d-flex justify-content-center align-items-center">
						<img :src="$imgURL + algumasMarcas.insInstitucionalImagens[0].itgUrlImagem"
							style="width: 100%; height: auto;">
						<div class="overlay"></div>

					</div>
					<div class="d-flex justify-content-center align-items-center">
						<p>{{ algumasMarcas.itiNome }}</p>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- END marcas -->


</template>

<script>
import PageCallAction from '@/components/PageCallAction.vue';
import { useHead } from '@vueuse/head';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/vue';
import PageSlider2 from '@/components/PageSlider2.vue';
import VueJsCounter from 'vue-js-counter';

export default {
	name: 'HomeView',
	components: {
		PageCallAction,
		Swiper,
		SwiperSlide,
		PageSlider2,
		VueJsCounter,
	},

	data: () => ({
		topoBanner: [],
		noticiasHome: [],
		titulosHome: [],
		listaDepoimentos: [],
		numeros: [],
		listaMarcas: [],
		produtosDestaque: [],
	}),

	methods: {
		formattedDate(value) {
			return this.$moment(value).format('DD/MM/YYYY')
		},

		formataLink(value) {
			return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
		},

		carregaMetas(texto) {
			useHead({
				title: 'Home - Induscapas',
				meta: [
					{ name: "description", content: texto },
					{ name: "author", content: "Induscapas" },
					{ httpEquiv: "Content-Language", content: "pt-BR" },
					{ charset: "UTF-8" },
					{ name: "robots", content: "index, follow" },
				],
			})
		},

		toggleAccordion(index) {
			this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
		},
	},

	created() {
		this.carregaMetas("---");

		//aqui busca numeros
		axios.get('/Process/InsInstitucional/institucional/14/numeros/0/x')
			.then(response => {
				this.numeros = response.data.filter(x => x.itiVisivel).sort((a, b) => {
					const valorA = parseInt(a.itiOrdem) || 0;
					const valorB = parseInt(b.itiOrdem) || 0;
					return valorA - valorB;
				});
				//console.log('numeros')
				//console.log(this.numeros)
			})
			.catch(error => {
				console.error(error);
			});
		//aqui busca produtos em destaque
		axios.get('/Process/InsInstitucional/institucional/39/listaprodutos/0/x')
			.then(response => {
				this.produtosDestaque = response.data.filter(x => x.itiVisivel && x.itiDestaque).sort((a, b) => {
					const valorA = parseInt(a.itiOrdem) || 0;
					const valorB = parseInt(b.itiOrdem) || 0;
					return valorA - valorB;
				});
				//console.log('produtos em destaque')
				//console.log(this.produtosDestaque)
			})
			.catch(error => {
				console.error(error);
			});

		//aqui busca noticias
		axios.get('/Process/InsInstitucional/institucional/46/listablog/0/x')
			.then(response => {
				this.noticiasHome = response.data.filter(x => x.itiVisivel).sort((a, b) => {
					const valorA = parseInt(a.itiOrdem) || 0;
					const valorB = parseInt(b.itiOrdem) || 0;
					return valorA - valorB;
				});
				//console.log('Noticias')
				//console.log(this.noticiasHome)
			})
			.catch(error => {
				console.error(error);
			});
		//aqui busca titulos
		axios.get('/Process/InsInstitucional/institucional/35/tituloshome/0/x')
			.then(response => {
				this.titulosHome = response.data;
				//console.log('titulos home')
				//console.log(this.titulosHome)
			})
			.catch(error => {
				console.error(error);
			});

		//aqui busca depoimentos
		axios.get('/Process/InsInstitucional/institucional/13/depoimentos/0/x')
			.then(response => {
				this.listaDepoimentos = response.data.filter(x => x.itiVisivel).sort((a, b) => {
					const valorA = parseInt(a.itiOrdem) || 0;
					const valorB = parseInt(b.itiOrdem) || 0;
					return valorA - valorB;
				});
				//console.log('depoimentos')
				//console.log(this.listaDepoimentos)
			})
			.catch(error => {
				console.error(error);
			});
		//aqui busca marcas
		axios.get('/Process/InsInstitucional/institucional/36/listamarcas/0/x')
			.then(response => {
				this.listaMarcas = response.data.filter(x => x.itiVisivel).sort((a, b) => {
					const valorA = parseInt(a.itiOrdem) || 0;
					const valorB = parseInt(b.itiOrdem) || 0;
					return valorA - valorB;
				});
				//console.log('lista de marcas')
				//console.log(this.listaMarcas)
			})
			.catch(error => {
				console.error(error);
			});

	},
}

</script>

<style scoped></style>
